var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('v-app',[_c('v-container',{attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('v-card',{staticClass:"rounded-md",attrs:{"outlined":"","width":"100%"}},[_c('order-list',{attrs:{"url":"site"}})],1)],1)],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }